import { callGetApi, callPutApi, callPostApi, callDeleteApi } from 'services/api/apiCallerProxy';
import { creativesLibraryApiFactory } from './creativesLibraryApiFactory';

export * from './hooks';
export const creativesLibraryApi = creativesLibraryApiFactory({ callGetApi, callPutApi, callPostApi, callDeleteApi });
